<template>
  <j-modal
    :okButtonProps="{ style: { display: 'none' } }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <iot-model-points-form
      :disabled="disableSubmit"
      :idType="idType"
      @ok="submitCallback"
      ref="realForm"
    ></iot-model-points-form>
  </j-modal>
</template>

<script>
import IotModelPointsForm from './IotModelPointsForm'
export default {
  name: 'IotModelPointsModal',
  components: {
    IotModelPointsForm
  },
  props: {
    deviceData: {
      type: Object,
      default: () => {}
    },
    idType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: '',
      width: 896,
      visible: false,
      disableSubmit: false
    }
  },
  methods: {
    add() {
      this.visible = true
      this.$nextTick(() => {
        const deviceId = this.deviceData && this.deviceData.id ? this.deviceData.id : ''
        this.$refs.realForm.add(deviceId, this.idType)
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record)
      })
    },
    copy(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.copy(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
